import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'

import SociedadPagePreview from './preview-templates/SociedadPagePreview'
import NuevosSociosPagePreview from './preview-templates/NuevosSociosPagePreview'
import NoticiaPagePreview from './preview-templates/NoticiaPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import ConferenciaPagePreview from './preview-templates/ConferenciaPagePreview'
import CapacitacionPagePreview from './preview-templates/CapacitacionPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('sociedad', SociedadPagePreview)
CMS.registerPreviewTemplate('nuevos-socios', NuevosSociosPagePreview)
CMS.registerPreviewTemplate('noticias', NoticiaPagePreview)
CMS.registerPreviewTemplate('conferencias', ConferenciaPagePreview)
CMS.registerPreviewTemplate('capacitaciones', CapacitacionPagePreview)